import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading, Text, TextLink } from '@frontend/design-system';

type Props = {
  heading?: string;
  body?: string;
};

export const BulkMessageError = ({ heading, body, ...rest }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  return (
    <section
      css={css`
        display: flex;
        border: solid 1px ${theme.colors.critical50};
        border-radius: ${theme.borderRadius.small};
        background: ${theme.colors.critical10};
        margin: auto;
        margin: ${theme.spacing(2, 0)};
        padding: ${theme.spacing(4)};
      `}
      {...rest}
    >
      <div
        css={css`
          margin-right: ${theme.spacing(1)};
          width: 64px;
        `}
      >
        <Icon name='error-badge' color='error' size={48} />
      </div>
      <div>
        <Heading
          level={2}
          css={css`
            margin-bottom: ${theme.spacing(1)};
          `}
        >
          {heading ? heading : t('An unexpected error occurred.')}
        </Heading>
        <Text>
          {body ? (
            body
          ) : (
            <Trans t={t}>
              Try <TextLink onClick={() => location.reload()}>reloading the page</TextLink>. If the problem persists,
              contact Weave Support at (888) 579-5668 or visit{' '}
              <TextLink to='https://weavehelp.com/'>Weave Help</TextLink>.
            </Trans>
          )}
        </Text>
      </div>
    </section>
  );
};
